// extracted by mini-css-extract-plugin
module.exports = {"white":"AppVersion_white__Qh4rU","black":"AppVersion_black__O1eW3","local":"AppVersion_local__leSib"};